// StorePage1.tsx
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import SubmitButton from "../../../components/form/SubmitButton";
import FileUpload from "../../../components/form/FileUpload";
import { useTranslation } from "react-i18next";
import InputField from "../../form/InputField";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import LoadingButton from "../../form/LoadingButton";
import { useSingleStoreAction } from "../../../hooks/store/store";
import LoadingErrorState from "../../ui/LoadingErrorState";

interface FormData {
  commercialRegister: string;
  taxNumber: string;
}

export default function UpdateTaxAndRegister() {
    const {t} = useTranslation();
    const { storeId} = useParams<{ storeId: string}>();
    const numericStoreId = storeId ? parseInt(storeId) : undefined;
    const {data:store,isError,isLoading} = useSingleStoreAction(numericStoreId);
    const { register, handleSubmit, setValue, formState: { errors }} = useForm<FormData>({
    defaultValues: { commercialRegister:"", taxNumber:"" }
  });

    useEffect(()=>{
        if(store){
            setValue("commercialRegister",store.commercialRegister);
            setValue("taxNumber",store.taxNumber);
        }
    },[store,setValue]);





    const [commercialFile, setCommercialRegisterFile] = useState<File | null>(null);
    const [taxFile, setTaxNumberFile] = useState<File | null>(null);


 const onSubmit = (data: FormData) => {
           // call API to create category
          const formData = new FormData();
          formData.append("commercialRegister",data.commercialRegister);
          formData.append("taxNumber",data.taxNumber)
          if(commercialFile){
            formData.append("commercialRegisterFile",commercialFile)
          }
          if(taxFile){
            formData.append("taxNumberFile",taxFile)
          }
           const url =numericStoreId?`store/update-legal-info?storeId=${numericStoreId}`:"store/update-legal-info";
           updateResource(url, formData ,numericStoreId? "admin":"store",{
             method: "PUT",
             successMessage: t("update_success"),
             invalidateQueries:["store-detail-action"],
           });
         };

    const { loading, updateResource } = useUpdateResource();
  
  return (
    <div className="">
        <LoadingErrorState
        isError={isError}
        isLoading={isLoading}
        />
        {
            store &&
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4 w-full">
            <div className="grid sm:grid-cols-2 gap-4">
                <InputField
                placeholder="0000-0000-00"
                label={t('commercialRegister')}
                register={register("commercialRegister", {
                    required: t("required_field"),
                    pattern: {
                    value: /^\d{10}$/,
                    message: t("invalid_commercialRegister"),
                  },
                })}
                error={errors.commercialRegister}
                />

                <InputField
                placeholder="0000-0000-0000-000"
                label={t('taxNumber')}
                register={register("taxNumber", {
                    required: t("required_field"),
                    pattern: {
                      value: /^(\d{10}|\d{15})$/,
                      message: t("invalid_tax_number_length"),
                    },
                })}
                error={errors.taxNumber}
                />
            </div>
            <div className=" grid grid-cols-2 gap-4">
                <FileUpload
                file={commercialFile}
                setFile={setCommercialRegisterFile}
                label={""}
                addText={t("add_commercialRegister_image")}
                shape="rectangle"
                size={128}
                initial={store?.commercialRegisterUrl??""}
                />

                <FileUpload
                file={taxFile}
                setFile={setTaxNumberFile}
                label={""}
                addText={t("add_taxNumber_image")}
                shape="rectangle"
                size={128}
                initial={store?.taxNumberUrl??""}
                />
            </div>
            <div className=''>
                {
                loading 
                ?
                <LoadingButton/>
                :
                <SubmitButton label='update'/>
                }
            </div>
        </form>
        }
    </div>
  );
}
